/*
 * File: WeSpeakPrivacyPolicy.styles.js
 * Project: our-wave-stories-app
 *
 * Created by Brendan Michaelsen on April 9, 2025 at 5:09 PM
 * Copyright © 2025 Our Wave, Inc. All rights reserved.
 *
 * Last Modified: May 31, 2025 at 10:23 PM
 * Modified By: Brendan Michaelsen
 */

/**
 * Imports
 */

// Modules
import styled from 'styled-components';


/**
 * Styles
 */

export const Wrapper = styled.div`
	max-width: 850px !important;
	margin: 0px auto;

	ul,
	li {
		font-size: 1.1rem;
	}
`;

export const TableOverflow = styled.div`
	overflow-x: scroll;
`;

export const Table = styled.table`
	border-collapse: collapse;
	border-spacing: 0;
	display: table;
	box-sizing: border-box;
	margin-top: 1.875rem;

	ul {
		margin-top: 0px !important;
		margin-bottom: 0px !important;
	}
	thead {
		background-color: ${({ theme }) => theme.secondaryBackground};
		display: table-header-group;
		vertical-align: top;
		border-color: inherit;
	}
	tr:first-child {
		border-top: 0.0625em solid ${({ theme }) => theme.layoutBorder};
	}
	tr {
		display: table-row;
		vertical-align: top;
		border-color: inherit;
		border-bottom: 0.0625em solid ${({ theme }) => theme.layoutBorder} !important;
	}
	td:first-child,
	th:first-child {
		border-left: 0.0625em solid ${({ theme }) => theme.layoutBorder};
	}
	td,
	th {
		border-right: 0.0625em solid ${({ theme }) => theme.layoutBorder};
		padding: 1.275rem;
	}
	td:nth-child(2) {
		white-space: normal;
	}
	th {
		text-align: left;
		font-weight: 700;
	}
	tbody {
		display: table-row-group;
		vertical-align: top;
		border-color: inherit;
	}
`;
